import merge from "lodash/merge";
import {
  getCurrentEnvironment,
  ENVIRONMENTS_ENUMS,
} from "../utilities/environmentUtils";

import baseConfig from "./repositoryConfig.json";
import devConfig from "./repositoryConfig.dev.json";
import prodConfig from "./repositoryConfig.prod.json";
import stgConfig from "./repositoryConfig.stg.json";

let environmentOverride;

const currentEnv = getCurrentEnvironment();
console.log("Current environment:", currentEnv);

switch (currentEnv) {
  case ENVIRONMENTS_ENUMS.DEV:
    environmentOverride = devConfig;
    break;
  case ENVIRONMENTS_ENUMS.STG:
    environmentOverride = stgConfig;
    break;

  case ENVIRONMENTS_ENUMS.PROD:
    environmentOverride = prodConfig;
    break;
  default:
    environmentOverride = {};
    break;
}

merge(baseConfig, environmentOverride);

const apiHost =
  process.env.REACT_APP_API_HOST || baseConfig.backendApiSettings.hostname;
console.log("API Host from env:", process.env.REACT_APP_API_HOST);
console.log("Using API Host:", apiHost);

baseConfig.backendApiSettings.hostname = apiHost;
console.log(
  "Final API URL:",
  `${baseConfig.backendApiSettings.schema}://${baseConfig.backendApiSettings.hostname}`
);

export const config = { ...baseConfig };
